<template>
  <div class="successPage">
    <tvu-top-header
      v-if='showHeader'
      ref="topHeaderRef"
      projectName="TVU networks"
      :globalFunList="['waffle','account']"
      :unUseDefaultMultiAccountModule="false"
      :serviceVesion="[]"
      @callback="topHeaderCallback">
    </tvu-top-header>
    <div class="contentBox">
      <div class="titleBox">
        <p class="bigTitle">Welcome to TVU</p>
        <p class="smallTitle">Making every transmission a success.</p>
      </div>
      <div :class="['serviceListBox scrollCss', isCenter ? 'center' : '']">
        <!-- https://tvuservices-dev.tvunetworks.com/tvuuserservice/package.serviceList/images/itemIcons/userserviceItem_icon.png -->
        <div
          v-for="(item, index) in serviceList"
          :key="index">
          <a
            v-if="!item.googleFlag"
            :href="getServiceUrl(item)"
            :target="item.publicFlag == '1' ? '_blank' : '_self'"
            @click="isRedirect(item.googleFlag)">
            <img
              :src="serviceIcon(item)"
              @error="useDefaultIcon"
              alt="" />
            <p>{{ item.serviceName }}</p>
          </a>
          <a
            v-else
            :href="getServiceUrl(item)"
            :target="item.publicFlag == '1' ? '_blank' : '_self'"
            @click.prevent="isRedirect(item.googleFlag)">
            <img
              :src="serviceIcon(item)"
              @error="useDefaultIcon"
              alt="" />
            <p>{{ item.serviceName }}</p>
          </a>
        </div>
      </div>
      <div class="content1"></div>
    </div>
  </div>
</template>
<script>
import Bus from '@/assets/js/vueBus'
import Cookies from 'js-cookie'
import { mapState } from 'vuex'
import { getUrlParam, removeCookie } from '@/assets/js/utils'
import Vue from 'vue'
import axios from 'axios'
import defaultServiceIcon from '@/assets/img/default-service.png'
export default {
  name: 'Success',
  data () {
    return {
      email: '',
      name: '',
      session: '',
      serviceList: '',
      userserviceAuthUrl: '',
      userserviceUrl: '',
      isCenter: false,
      protocol: window.location.protocol,
      userManagerUrl: '',
      domainName: '',
      showHeader: false
    }
  },
  computed: {
    ...mapState({
      httpsFlag: 'httpsFlag'
    })
  },
  created () {
    const localUrl = window.location.hostname
    const str1 = localUrl.split('.')[1]
    const str2 = localUrl.split('.')[2]
    this.domainName = `.${str1}.${str2}`
    // this.session = Cookies.get('SID') || localStorage.getItem('session') || ''
    this.session = localStorage.getItem('session')
    // 从sso页面进入需要在cookie里设置当前用户的tag cookie
    if (getUrlParam('fromPage') === 'sso') {
      this.$store.state.validSid = true
      this.userTag()
      // this.goSearchPlugin()
    }
  },
  mounted () {
    if (!this.$store.state.validSid) {
      this.$router.push({ name: 'SignInPage' })
      return
    }
    this.userserviceAuthUrl = localStorage.getItem('userserviceAuthUrl')
    this.userserviceUrl = localStorage.getItem('userserviceUrl')
    Vue.prototype.$TVU = {
      http: axios,
      serverName: 'TVU networks',
      userAuthUrl: this.userserviceAuthUrl && this.userserviceAuthUrl.split('//')[1],
      domain: window.location.origin
    }
    setTimeout(() => {
      this.showHeader = true
    }, 100)
    this.getServiceList()
  },
  methods: {
    // iconName 后端存的是完整 CDN URL（dl.tvunetworks.com/static/userservice/waffles/），
    // 少数服务该字段为空，兜底用本地默认图（CDN waffles/Default Icon.png 的副本，与九宫格给无图标服务显示的图一致）
    serviceIcon (item) {
      const iconName = (item && item.iconName) || ''
      return /^https?:\/\//.test(iconName) ? iconName : defaultServiceIcon
    },
    useDefaultIcon (e) {
      if (e.target.dataset.fallbackApplied) return
      e.target.dataset.fallbackApplied = 'true'
      e.target.src = defaultServiceIcon
    },
    async getUserInfo () {
      await this.axios
        .get(`${this.userserviceAuthUrl}/main/getUserInfoBySession`).then(({ data }) => {
          if (data.errorCode == '0x0') {
            let { id, firstName, userName, email } = data.result
            const sourceUrl = encodeURIComponent(window.location.origin + window.location.pathname)
            this.userManagerUrl = `${this.userserviceAuthUrl.replace('userAuth', 'user-group')}/?userId=${id}&source=${sourceUrl}&mark=group_user_detail_info#/ug`
            // 获取name和email
            this.email = email
            this.name = firstName || userName || email
            this.goSearchPlugin()
            // if (getUrlParam('fromPage') === 'sso') {
            //   this.goSearchPlugin()
            // }
          }
        }).catch()
    },
    isRedirect (googleFlag) {
      if (googleFlag) {
        this.$message({
          message:
            'TVU administrator and support accounts must use \'Login with Google\' for access.',
          type: 'error',
          duration: 3000
        })
      }
    },
    goSearchPlugin () {
      if (window.__adobe_cep__) {
        const oneWeekFromNow = new Date()
        oneWeekFromNow.setDate(oneWeekFromNow.getDate() + 30)
        const expires = oneWeekFromNow.toUTCString()
        window.document.cookie = `SID=${this.session};path=/;domain=${this.domainName};secure;samesite=none`
        window.document.cookie = `loginKey=${this.session};expires=${expires};path=/;domain=${this.domainName};secure;samesite=none`
        fetch('/userGroup/user-group/user/setLoginKey', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            uuid: this.session,
            email: this.email,
            type: 1
          })
        }).then(() => {
          const num = history.length
          history.go(1 - num)
        }).catch(() => {
          const num = history.length
          history.go(1 - num)
        })
      }
    },
    getServiceList () {
      // https://10.12.22.101/userAuth/main/ListAccessableService?session=35744FE0C4E347E1B1BA22E70D5BCBF9
      this.axios
        .get(`${this.userserviceAuthUrl}/main/listBoxServices`).then(async (res) => {
          if (res.data.errorCode == '0x0') {
            this.serviceList = []
            await this.getUserInfo()
            this.serviceList.push({
              description: 'User Profile',
              publicFlag: '1',
              googleFlag: false,
              serviceType: 'UserService',
              serviceName: 'User Profile',
              // v1 接口不返回该条目，图标用与 tvu-common-ui 九宫格（v2 接口）同源的 CDN 图
              iconName: 'https://dl.tvunetworks.com/static/userservice/waffles/User%20Profile.png',
              url: this.userManagerUrl
            })
            this.serviceList = this.serviceList.concat(
              res.data.result
            )
            this.$nextTick(() => {
              if (document.querySelector('.serviceListBox')) {
                if (Math.floor((document.querySelector('.serviceListBox').offsetWidth - 180) / 240) > this.serviceList.length) {
                  this.isCenter = true
                } else {
                  this.isCenter = false
                }
              }
            })
          } else if (res.data.errorCode == '0x80060005') {
            // localStorage.removeItem('session');
            // Bus.$emit('jumpLoginPage');
          }
        })
        .catch()
    },
    getServiceUrl (item) {
      let url = ''
      if (item.serviceName === 'User Profile') {
        return item.url
      }
      if (item.url.indexOf('../') != -1) {
        const _url = item.url.split('..')[1]
        url = this.userserviceUrl + _url
      } else {
        url = item.url
      }
      if (url.indexOf('http') == -1) {
        url = 'http://' + url
      }
      if (item.appendSession) {
        url = url + '?session=' + this.session
      }
      return url
    },
    topHeaderCallback (data) {
      if (data.type === 'signOut' || data.type === 'sessionExpired') {
        this.logout()
      }
    },
    logout () {
      // ga('send', 'event', 'newUserService-success-logout', 'click')
      gtag('event', 'newUserService-success-logout')
      this.axios.get('/userGroup/user-group/login/logout').then((res) => {
        if (res.data.errorCode == '0x0') {
          Cookies.remove('email', { domain: 'tvunetworks.com' })
          Cookies.remove('firstName', { domain: 'tvunetworks.com' })
          Cookies.remove('userName', { domain: 'tvunetworks.com' })
          // const exp = new Date()
          // exp.setTime(exp.getTime() - 1)
          // window.document.cookie = `email=;path=/;domain=tvunetworks.com;expires=${exp.toGMTString()};`
          // window.document.cookie = `firstName=;path=/;domain=tvunetworks.com;expires=${exp.toGMTString()};`
          // window.document.cookie = `userName=;path=/;domain=tvunetworks.com;expires=${exp.toGMTString()};`
          localStorage.removeItem('email')
          localStorage.removeItem('firstName')
          localStorage.removeItem('userName')
          localStorage.removeItem('session')
          localStorage.removeItem('userserviceAuthUrl')
          localStorage.removeItem('userserviceUrl')
          Bus.$emit('jumpLoginPage')
        } else {
          this.$message({
            message: 'login defeat',
            type: 'error',
            duration: 3000
          })
        }
      }).catch()
    },
    userTag () {
      this.axios.get('/userGroup/user-group/user/getUserTag').then((res) => {
        if (res.data.errorCode == '0x0') {
          const addTag = res.data.result && res.data.result.addTags
          const delTag = res.data.result && res.data.result.delTags
          // 先删除所有的tag cookie
          if (delTag && delTag.length > 0) {
            delTag.forEach(itm => {
              removeCookie(itm, this.domainName)
            })
          }
          // 再添加当前用户的tagcookie
          if (addTag && addTag.length > 0) {
            addTag.forEach(itm => {
              window.document.cookie = `${itm.tagKey}=${itm.tagValue};path=/;domain=${this.domainName};${this.httpsFlag ? 'secure' : ''}`
            })
          }
        }
      }).catch()
    }
  },
  beforeRouteEnter (to, from, next) {
    // 如果有cookie isSuccess为true，只有为true才可以进入到welcome页面
    if (localStorage.getItem('session')) {
      next((vm) => {
        vm.$store.state.isSuccess = true
      })
    } else {
      // 没有sid，则跳转到signIn页面
      setTimeout(() => {
        next({ name: 'SignInPage' })
      }, 0)
    }
  },
  beforeRouteLeave (to, from, next) {
    next((vm) => {
      vm.$store.state.isSuccess = false
    })
  }
}
</script>
